<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <AbsentChartFilter @onFilterChanged="refresh" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView :content="'Tìm kiếm'" />
    </div>

    <v-card v-else class="ma-6" outlined>
      <AbsentChart ref="diligence-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
import AbsentChartFilter from './components/AbsentChartFilter.vue'
import AbsentChart from './components/AbsentChart.vue'
import StudentBlankView from '@/components/basic/StudentBlankView.vue'

export default {
  components: {
    AbsentChart,
    AbsentChartFilter,
    StudentBlankView,
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      filters: null,
      currClass: null
    }
  },
  methods: {
    refresh(query) {
      this.action.state = 'filtered'
      this.filters = query
      this.$nextTick(() => {
        this.$refs['diligence-data-table'].searchStudentDiligences()
      })
    }
  }
}
</script>
